
/* eslint-disable-next-line */
(function ($) {
	$(document).ready(function(){

		$('.orange-block[class*=" block-divider"]').each(function(){

			let thisBlock = this;

			$(this).attr("class").split(/\s+/).forEach(function(className){

				if(className.startsWith("block-divider")){

					className = className.replace("block-divider-", "");

					let dividerInfo = className.split(/-(?=[^-]*$)/);

					let dividerLocation = (dividerInfo[1] === "ontop") ? "top" : "bottom";
					let dividerShapeType = dividerInfo[0];

					let dividerHtml = getBlockDividerHtml(dividerLocation, dividerShapeType);

					if(dividerLocation === "top"){
						$(thisBlock).prepend(dividerHtml);
					}else{
						$(thisBlock).append(dividerHtml);
					}

					if(dividerLocation === "bottom"){

						let neighbouringBlock = $(thisBlock).next(".orange-block");

						if(neighbouringBlock.length > 0){

							let updatedPaddingTop = parseInt(neighbouringBlock.css("padding-top")) + $(thisBlock).find(".block-divider-bottom").outerHeight();

							neighbouringBlock.css("--block-padding-top", updatedPaddingTop + "px");

						}

					}

				}

			});

		});

	});


	let dividerShapes = {
		"wave": {
			"top": [
				'<path d="M0,17.174S110.281-10.837,358.828-.744,742.4,29.534,994.189,39.626,1366,26.934,1366,26.934V47.445H0Z" transform="translate(0 2.938)"/>',
			],
			"bottom": [
				'<path d="M1366,27.332s-110.281,28.011-358.828,17.918S623.6,14.973,371.811,4.88,0,17.572,0,17.572V-2.938H1366Z" transform="translate(0 2.938)"/>',
			],
			"width": 1366,
			"height": 50,
		},
		"organic-wave": {
			"top": [
				'<path d="M387.58,10.75C224.89,10.75,120.24,7.79,0,5V30H1600V5c-109.6-2.57-232.15-5-423.42-5C776.58,0,676.58,10.75,387.58,10.75Z"/>',
				'<path d="M1070,10.75C759,10.75,660.1-.06,259,0,155.36,0,71.87.72,0,1.79V30H1600V1.79C1394.5,4.85,1284.12,10.75,1070,10.75Z"/>',
				'<path d="M789,0C389,0,289,10.75,0,10.75V30H1600V10.75C1289,10.75,1190.1-.06,789,0Z"/>',
			],
			"bottom": [
				'<path d="M1212.42,19.25c162.69,0,267.34,3,387.58,5.77V0H0V25c109.6,2.57,232.15,5,423.42,5C823.42,30,923.42,19.25,1212.42,19.25Z"/>',
				'<path d="M530,19.25c311,0,409.9,10.81,811,10.75,103.64,0,187.13-.72,259-1.79V0H0V28.21C205.5,25.15,315.88,19.25,530,19.25Z"/>',
				'<path d="M811,30c400,0,500-10.75,789-10.75V0H0V19.25C311,19.25,409.9,30.06,811,30Z"/>',
			],
			"width": 1600,
			"height": 30,
		},
	};

	let getBlockDividerHtml = function(location, shapeType){

		let shapeInfo = dividerShapes[shapeType];

		let shapePath = "";

		if(shapeInfo[location].length > 1){

			// Randomly select an index in the array
			let index = Math.floor(Math.random() * shapeInfo[location].length);

			shapePath = shapeInfo[location][index];

		}else{

			shapePath = shapeInfo[location];

		}

		const dividerHtml =
			'<div class="block-divider-' + location + '">' +
				'<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 ' + shapeInfo.width + ' ' + shapeInfo.height + '" preserveAspectRatio="none">' +
					'<g fill="var(--' + location + '-divider-color, white)">' + shapePath + '</g>' +
				'</svg>' +
			'</div>';

		return dividerHtml;

	};

	/* eslint-disable-next-line */
})(jQuery);